import React from 'react';

import { ClaimItemBase } from '../types';

import AdjusterAssignmentIcon from '~/core/iconComponents/icons/actions/AdjusterAssignmentIcon.tsx';
import AssessDamageIcon from '~/core/iconComponents/icons/actions/AssessDamageIcon.tsx';
import CommunicateIcon from '~/core/iconComponents/icons/actions/CommunicateIcon.tsx';
import DecideOnCoverageIcon from '~/core/iconComponents/icons/actions/DecideOnCoverageIcon.tsx';
import InvoiceAnalysisIcon from '~/core/iconComponents/icons/actions/InvoiceAnalysisIcon.tsx';
import LayerAdviceIcon from '~/core/iconComponents/icons/actions/LayerAdviceIcon.tsx';
import OpenExposureIcon from '~/core/iconComponents/icons/actions/OpenExposureIcon.tsx';
import PaymentIcon from '~/core/iconComponents/icons/actions/PaymentIcon.tsx';
import SetReserveIcon from '~/core/iconComponents/icons/actions/SetReserveIcon.tsx';
import UpdateReserveIcon from '~/core/iconComponents/icons/actions/UpdateReserveIcon.tsx';
import ErrorIcon from '~/core/iconComponents/icons/ErrorIcon.tsx';
import type { IconProps } from '~/core/iconComponents/types';

export type ActionType =
  | 'decide_on_coverage'
  | 'update_reserve'
  | 'payment'
  | 'invoice_analysis_recommendation'
  | 'assess_damage'
  | 'communicate'
  | 'adjuster_assignment'
  | 'open_exposure'
  | 'set_reserve'
  | 'layer_advice'
  | 'general'
  | 'http_general';

export interface Action extends ClaimItemBase {
  type: ActionType;
  is_done: boolean;
  is_dismissed: boolean;
}

// API response interface for actions
export interface ActionListResponse {
  actions: Action[];
}

export const ACTION_ICON_MAP: Record<ActionType, React.ComponentType<IconProps>> = {
  decide_on_coverage: DecideOnCoverageIcon,
  update_reserve: UpdateReserveIcon,
  payment: PaymentIcon,
  invoice_analysis_recommendation: InvoiceAnalysisIcon,
  assess_damage: AssessDamageIcon,
  communicate: CommunicateIcon,
  adjuster_assignment: AdjusterAssignmentIcon,
  open_exposure: OpenExposureIcon,
  set_reserve: SetReserveIcon,
  layer_advice: LayerAdviceIcon,
  general: ErrorIcon,
  http_general: ErrorIcon,
};

export interface AiDoneActionNote {
  action_type?: string;
  note_text: string;
}

export interface ActionTaskData {
  task_id?: string;
  task_text: string;
  explanation: string;
  additional_actions?: string;
  done_action?: AiDoneActionNote;
  related_exposure_id?: string;
  task_type?: string;
}

export type CoverageDecisionRecommendation = 'approve' | 'deny';
export type CoverageIssueType =
  | 'incident_date_outside_policy_period'
  | 'incident_date_close_to_policy_boundaries'
  | 'loss_not_covered'
  | 'loss_meets_exclusion_criteria'
  | 'other';

export interface CoverageIssue {
  issue_type: CoverageIssueType;
  issue_description: string;
  recommended_action: CoverageDecisionRecommendation;
  explanation: string;
  quote_from_incident?: string;
  quote_from_policy?: string;
}

export interface CoverageTestResult {
  test_description: string;
  test_passed: boolean;
  issue?: CoverageIssue;
}
